import { FC } from "react";

import Icon from "@/components/ui/Icon/Icon";
import { SwitchButtonProps } from "@/types";
import cn from "@/utils/cn";

const SwitchButton: FC<SwitchButtonProps> = ({ label, selected, clickHandler, type = "button", customClass = "" }) => {
  return (
    <button
      type="button"
      className={`flex items-center justify-between py-xs px-xs rounded-full ${selected ? "golden-gradient text-black" : "text-gray-70"}`}
      onClick={clickHandler}
    >
      <span className={cn(`text-m ${type === "button" ? "pr-s" : " pr-0"}`, customClass)}>{label}</span>
      {selected && type === "button" && <Icon name="check" size="20" title="check" />}
    </button>
  );
};
export default SwitchButton;
